import React from "react"

import { scale } from "utils"

const PlLineTitle = (props) => {
  const { templateType, title } = props

  const styles =
    templateType === "thermal" ? stylesThermal : stylesOthers

  return (
    <div style={styles["lineTitleContainer"]}>
      <div style={styles["lineTitle"]}>
        <div style={styles["lineTitleTextWrapper"]}>
          <div style={styles["line"]} />
        </div>
        <div style={styles["lineTitleTextWrapper"]}>
          {title}
        </div>
      </div>
    </div>
  )
}

const stylesThermal = {
  lineTitleContainer: {
    position: "relative",
    margin: scale("8px")
  },
  lineTitle: {
    height: scale("38px")
  },
  lineTitleTextWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: `0px ${scale("4px")}`,
    fontSize: scale("24px"),
    backgroundColor: "#fff",
  },
  line: {
    width: "100%",
    borderBottom: `${scale("2px")}dashed black`
  }
}

const stylesOthers = {
  lineTitleContainer: {
    marginRight: "8px",
    position: "relative",
    margin: "8px 0px",
    fontSize: "11px"
  },

  lineTitle: {
    height: "20px"
  },

  lineTitleTextWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 4px",
    backgroundColor: "#fff"
  },
  line: {
    width: "100%",
    borderBottom: "2px dashed black"
  }
}

export default PlLineTitle